module.exports = __webpack_public_path__ + "img/134.27c4ae2e.jpg";